import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query highDemand($tenantId: ID!, $suggestionsListId: ID!) {
    highDemand(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
